class FBLearnmore {
  constructor(
    title,
    informationChunks,
    subrightID,
    titleHash,
    hashedInfoChunks
  ) {
    this.title = title;
    this.informationChunks = informationChunks;
    this.subrightID = subrightID;
    this.titleHash = titleHash;
    this.hashedInfoChunks = hashedInfoChunks;
  }
}

export default FBLearnmore;
